import {
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import ESigningRequestPreparingImageBuyer from 'assets/images/ESigningRequestPreparingImageBuyer.png';
import { poppins300 } from 'theme/common.style';
import CustomStepperAgent from 'component/BannerComponents/AgentBanners/CustomStepperAgent';
import BannerMoreInfoDialog from 'component/BannerComponents/BannerMoreInfoDialog';

const Step2ESignRequestPreparing = (props) => {
  const { isBuyerDashboard, getBuyerIndividualValue, buyerDashboardDetails } =
    props;

  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  };
  const onOpen = () => {
    setOpen(true);
  };

  const buyerName = isBuyerDashboard
    ? `${buyerDashboardDetails?.agentDetails?.agentName} ${buyerDashboardDetails?.agentDetails?.agentSurName}`
    : `${getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentName} ${getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentSurName}`;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: 'rgba(33, 132, 253, 0.8)',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '0 0 20px 0' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container xs={12} md={12}>
          <Grid item container xs={12} md={9}>
            <Grid item xs={12}>
              <Stack
                direction={'column'}
                padding={matchessm ? '10px 10px 0 10px' : '30px 0 0 33px'}
              >
                <Typography
                  sx={{
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>
                <Typography
                  sx={{
                    fontSize: matchessm ? '16px' : '28px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 1)',
                    fontFamily: 'poppins',
                    mt: !matchessm && '10px',
                  }}
                >
                  E-Sign Request -&nbsp;
                  {buyerName}
                  &nbsp; preparing Contract of Sale for E-Sign
                </Typography>
                <Typography
                  sx={{
                    fontSize: matchessm ? '13px' : '16px',
                    fontFamily: 'Poppins',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    marginTop: matchessm ? '10px' : '10px',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '13px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {buyerName}
                  </span>
                  &nbsp;is currently preparing the contract of sale for&nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '13px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName ||
                      buyerDashboardDetails?.propertyAddress?.streetName}
                    .
                  </span>
                  &nbsp; Once ready to sign you will be notified. Please be
                  ready to sign the contract promptly. Delayed signing can
                  breach the terms and conditions.
                </Typography>
              </Stack>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: 'flex',
                  justifyContent: matchessm ? 'space-between' : 'start',
                  gap: matchessm ? 1 : 2,
                  padding: matchessm ? '0 10px 0 10px' : '0 0 0 33px',
                  marginBottom: matchessm ? '5px' : 0,
                }}
              >
                <Button
                  onClick={onOpen}
                  sx={{
                    minWidth: matchessm ? 'auto' : '125px',
                    gap: matchessm ? '5px' : '10px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: '#FFFFFF',
                    color: '#2184FD',
                    '&:hover': {
                      bgcolor: '#FFFFFF',
                      color: '#2184FD',
                    },
                  }}
                >
                  More Info
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} alignItems={'center'}>
                <CustomStepperAgent stepValue={1} requestEsign={true} />
              </Grid>
            </Grid>
          </Grid>
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={ESigningRequestPreparingImageBuyer}
                alt="ESigningRequestPreparingImageBuyer"
                style={{
                  objectFit: 'contain',
                  height: '257px',
                  width: '264px',
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
      {open && (
        <BannerMoreInfoDialog
          open={open}
          onClose={onClose}
          userName={buyerName}
          status={'PREPARING_CONTRACT'}
        />
      )}
    </>
  );
};

export default Step2ESignRequestPreparing;
